import KendoTreeMap from '../KendoTreeMap'

let KendoTreeMapInstaller = class {
    static install(Vue) {
        Vue.component(KendoTreeMap.name, KendoTreeMap)
    }
}

export default KendoTreeMapInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoTreeMapInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-treemap-vue-wrapper/src/kendo-treemap-installer/index.js